<template>
  <div class="animated fadeIn">        
    <b-card v-if="(showForm==false)">
        <div slot="header">
            Template Jurnal Eliminasi
            <div class="card-header-actions">
            <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
            <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
            <b-button variant="btn btn-primary mr-1" @click="exportxls">Export</b-button>
            <b-button variant="btn btn-primary" @click="close">Close</b-button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
        </div>
        <b-row >
            <b-col lg="4">
                <b-input-group size="sm" v-if="(filterShow=='Hide')">
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1"></b-form-checkbox>
                    <b-input-group-prepend> <span class="pt-1 pr-2">
                        <b> {{ filterShow }}</b>  Filter </span>
                    </b-input-group-prepend>
                    <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group >
                <b-input-group size="sm" v-else>
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1">
                </b-form-checkbox>
                    <b-input-group-prepend> <span class="pt-1 pr-2">
                        <b> {{ filterShow }}</b>  Filter </span>
                    </b-input-group-prepend>
                </b-input-group>
            </b-col>
        </b-row>
        <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive striped hover
            style="font-size:smaller;" 
            :items="getData"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
        >
            <template v-slot:thead-top="data">
                <b-tr>
                    <b-th colspan="2"><span class="sr-only"></span></b-th> 
                    <b-th variant="success" colspan="2" class="text-center">DEBIT</b-th>
                    <b-th variant="warning" colspan="2" class="text-center">CREDIT</b-th>
                    <b-th><span class="sr-only"></span></b-th> 
                </b-tr>
            </template>
            <template v-slot:cell(kodeacc_db)="data">
            {{data.item.kodeacc_db}} | {{data.item.namaacc_db}}
            </template>
            <template v-slot:cell(kodeacc_cr)="data">
            {{data.item.kodeacc_cr}} | {{data.item.namaacc_cr}}
            </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
        </b-table>
        <b-row class="mt-2">
            <b-col cols="4">
            <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
            </div>
            </b-col>
            <b-col cols="4" >
                <b-form-group label-cols=3 label="Limit per page" class="mb-0">
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
                </b-form-group>
            </b-col>        
            <b-col cols="4">            
            <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
            ></b-pagination>
            </b-col>
        </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="(showForm==true)">
      <b-col md="8" lg="6">
            <b-card >
            <div slot="header">Template Eliminasi - Add/Edit Form 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                    <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
            </div>
              <b-input-group >
                <b-input-group-prepend><label>Uraian Eliminasi</label></b-input-group-prepend>
                  <b-form-input  v-model="frmdata.uraian" :state="!$v.frmdata.uraian.$error"></b-form-input>
              </b-input-group>
              <h4>DEBIT</h4>
              <b-input-group >
                <b-input-group-prepend><label>Debit Account</label></b-input-group-prepend>
                  <b-form-input  v-model="frmdata.kodeacc_db" placeholder="Account Code" :state="!$v.frmdata.kodeacc_db.$error"></b-form-input>
                  <b-form-input v-model="frmdata.namaacc_db" class="ml-1" placeholder="Account Name" style="width:40% !important;" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('db')">
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Unit Bisnis</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.company_db" :state="!$v.frmdata.compcode_db.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCompany('db')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <h4>CREDIT</h4>
              <b-input-group >
                <b-input-group-prepend><label>Credit Account</label></b-input-group-prepend>
                  <b-form-input  v-model="frmdata.kodeacc_cr" placeholder="Account Code" :state="!$v.frmdata.kodeacc_cr.$error"></b-form-input>
                  <b-form-input v-model="frmdata.namaacc_cr" class="ml-1" placeholder="Account Name" style="width:40% !important;" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="showLkuCoa('cr')">
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Unit Bisnis</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.company_cr" :state="!$v.frmdata.compcode_cr.$error"></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCompany('cr')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
            </b-card>
          </b-col>
    </b-row>

        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        </b-modal>

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="Consolidation Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="Consolidation Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                width: 160px !important;
            }
        }
    }

</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuCoa from "../lookup/lkuConsolidaCoa";
import lkuCompany from "../lookup/lkuConsolidaCompany"
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, lkuCoa, lkuCompany},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            uraian: { required },
            compcode_db: { required },
            compcode_cr: { required },
            kodeacc_db: { required },
            kodeacc_cr: { required }
        }
  }, 
  data() {
    return {
      showDelConfirm:false,
      user: this.$store.state.user,
      model:{},
      tblData: {
        items:[],
        tablename:'elimination-template',
        page: 1,
        total: 0,
        limit:10,
        sortBy: 'uraian',
        sortDesc: true
      },
      tblFields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "uraian",
            label: "Uraian eliminasi",
            sortable: true
          },
          {
            key: "Kodeacc_db",
            label: "Account",
            sortable: true
          },
          {
            key: "company_db",
            label: "Unit Bisnis",
            sortable: true
          },
          {
            key: "Kodeacc_cr",
            label: "Account",
            sortable: true
          },
          {
            key: "company_cr",
            label: "Unit Bisnis",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
      ],

        showForm:false,  
        frmdata:{ uraian: '',
            compcode_db: '',
            compcode_cr: '',
            kodeacc_db: '',
            kodeacc_cr: '',
            templatekey:''
            },  
        filter: null,
        filterOn:null,
        filterShow: 'Show',
        saveEnabled:true,isLoading:false,

        lkuCoaShow:false,
        lkuCoaCaller:'adv',
        tahun:(this.$store.state.user.tglaktifconsol || '').substring(0,4),
        lkuCompanyShow:false
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
//   created: async function() {
//     this.companies= await mapcoa.companies();
//   },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`kodeacc_${this.lkuCoaCaller}`] = _selected.kodeacc;
            this.frmdata[`namaacc_${this.lkuCoaCaller}`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    showLkuCompany(callerObj)
    {
      this.lkuCompanyShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCompany: async function (_selected) {
        this.frmdata[`compcode_${this.lkuCoaCaller}`] = _selected.compcode;
        this.frmdata[`company_${this.lkuCoaCaller}`] = _selected.company;
        this.lkuCompanyShow=false;
    },  
    getData: async function(ctx) {
        try {
          this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            this.tblData.customQuery = 'holdingcode=' + encodeURIComponent(this.user.compcode);
            // console.log(this.tblData.customQuery);
            const list = await crud.list(this.tblData);    
          this.isLoading=false;    
          return list;

          } catch (error) {
                  this.isLoading=false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.isLoading=false;            
          }
    },   
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
          await crud.remove({tablename:'elimination-template', key:this.model.templatekey});
          this.getData();
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }

    },

    add: function(){
        this.frmdata.uraian=''; 
        this.frmdata.kodeacc_db=''; 
        this.frmdata.namaacc_db=''; 
        this.frmdata.compcode_db=''; 
        this.frmdata.company_db=''; 
        this.frmdata.kodeacc_cr=''; 
        this.frmdata.namaacc_cr=''; 
        this.frmdata.compcode_cr=''; 
        this.frmdata.company_cr=''; 
        this.frmdata.templatekey=''
        this.showForm=true;
    } , 
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.showForm=true;
      this.showList=false;
    },
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;             
        if (this.invalidFrmdata) {
            const invalidobj={};
            for (var key in this.$v.frmdata) {
              if (this.$v.frmdata[key].$anyError) {
                if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
              }
            }        
            console.log('validation frmdata: ', this.$v.frmdata);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;             
        } else {
            try {
              const data = {};
                data.uraian = this.frmdata.uraian;
                data.kodeacc_db = this.frmdata.kodeacc_db;
                data.namaacc_db = this.frmdata.namaacc_db;
                data.compcode_db = this.frmdata.compcode_db;
                data.company_db = this.frmdata.company_db;
                data.kodeacc_cr = this.frmdata.kodeacc_cr;
                data.namaacc_cr = this.frmdata.namaacc_cr;
                data.compcode_cr = this.frmdata.compcode_cr;
                data.company_cr = this.frmdata.company_cr;
                data.holdingcode  =  	 this.user.compcode; 

                if (this.frmdata.templatekey){
                      await crud.update({tablename:'elimination-template', key:this.frmdata.templatekey, data});
                } else {
                    await crud.insert({ tablename:'elimination-template', data});
                }
                toastr.success("Template Reklas/Elimnasi Saved");   
                setTimeout(() => {
                    this.refresh();              
                }, 100);       
                this.closeFrm();              
                this.saveEnabled=true;             
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Template Reklas/Elimnasi Error");   
                this.saveEnabled=true;             
            }
        }
    },    
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.filter);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.customQuery = 'holdingcode=' + encodeURIComponent(this.user.compcode);
                const response = await crud.exportxls(this.tblData);    
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Template_Elimnasi_${this.user.compcode}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);

                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },    
    closeFrm(){
          this.showForm=false;
    },
    close(){
          router.push("home");
    },

  }
};
</script>
